import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from 'antd';
import { useI18n } from '@newtontechnologies/applib-frontend';
import SplitPart from './SplitPart';
const formatSplitDuration = (duration) => {
    const hours = duration.slice(0, 2);
    const minutes = duration.slice(3, 5);
    if (hours === '00') {
        return `${Number(minutes)}m`;
    }
    return `${Number(hours)}h ${minutes}m`;
};
const SplitFiles = ({ task }) => {
    const { intl } = useI18n();
    const [partsVisible, setPartsVisible] = useState(false);
    return (_jsxs("div", { className: "split-files", children: [_jsxs("span", { children: [intl.formatMessage({ id: 'partLength' }), ': ', formatSplitDuration(task.splitDuration)] }), task.splitFiles.length > 0 ? (_jsx(Button, { type: "link", onClick: () => setPartsVisible(!partsVisible), children: partsVisible ? (intl.formatMessage({ id: 'hideDetails' })) : (intl.formatMessage({ id: 'showDetails' })) })) : null, _jsx("div", { className: "parts-list", children: partsVisible ? (task.splitFiles.map((part) => _jsx(SplitPart, { task: task, split: part }, part.id))) : null })] }));
};
export default SplitFiles;
